import type { Notification } from '@nuxt/ui/dist/runtime/types/notification'

export const toastError = (options: Partial<Notification>): void => {
  toast().add({ ...options, timeout: options?.timeout ?? 2 * 1000, color: 'red' })
}
